import { render } from "./ManualGeneration.vue?vue&type=template&id=5ee7dbd0&scoped=true&ts=true"
import script from "./ManualGeneration.vue?vue&type=script&lang=ts"
export * from "./ManualGeneration.vue?vue&type=script&lang=ts"

import "./ManualGeneration.vue?vue&type=style&index=0&id=5ee7dbd0&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee7dbd0"]])

export default __exports__